import { getOperatorOptions } from '../logicHelpers'

const utmSource = () => ({
  types: [
    { label: 'UTM Source', value: 'utm_source', description: 'Where the traffic came from' },
    { label: 'UTM Medium', value: 'utm_medium', description: 'The marketing channel' },
    { label: 'UTM Campaign', value: 'utm_campaign', description: 'The campaign name' },
    { label: 'UTM Term', value: 'utm_term', description: 'The paid search keyword' },
    { label: 'UTM Content', value: 'utm_content', description: 'Which ad or link they clicked' }
  ],
  inputs: [
    {
      control: 'select',
      key: 'occurrence-select',
      name: 'occurrence',
      options: [
        { label: 'On most recent occurrence', value: 'last touch' },
        { label: 'On current page', value: 'last' },
        { label: 'On first occurrence', value: 'first touch' },
        { label: 'On first ever page hit', value: 'first' },
        { label: 'On any occurrence', value: 'any' }
      ],
      can: (condition: { $source: string }) => condition.$source === 'utm'
    },
    {
      control: 'select',
      key: 'operator-select',
      name: 'operator',
      options: getOperatorOptions(),
      can: (condition: { $source: string }) => condition.$source === 'utm'
    },
    {
      control: 'text',
      key: 'value-input',
      name: 'value',
      can: (condition: { $source: string; operator: string }) =>
        condition.$source === 'utm' && condition.operator !== 'is set' && condition.operator !== 'is not set'
    }
  ]
})

export default utmSource
